import { Component } from '@angular/core';
import { APP_VERSION } from '../../app-version';

/**
 * One entry per release, newest first.
 *
 * The prose lives in the translation files rather than here, because this
 * application is used in three languages and a release note nobody can read is
 * not a release note. Adding a release means an entry here plus its keys in
 * en.json, fr.json and nl.json -- deliberately the same cost as any other user-
 * facing text, rather than a second class of string that quietly stays English.
 *
 * `date` is the release date in ISO form so it sorts and formats per locale.
 * The order in this array is the order shown; it is not sorted at runtime,
 * because a release that was cut before another but published after should
 * appear where whoever wrote it decided.
 */
export interface Release {
    version: string;
    date: string;
    /** Translation key for the one-line summary. */
    summaryKey: string;
    /** Translation keys for the bullet points, in the order they are shown. */
    pointKeys: string[];
}

export const RELEASES: readonly Release[] = [
    {
        version: '7.0.1',
        date: '2026-09-14',
        summaryKey: 'RELEASE.V701.SUMMARY',
        pointKeys: [
            'RELEASE.V701.P1',
            'RELEASE.V701.P2',
            'RELEASE.V701.P3',
            'RELEASE.V701.P4',
            'RELEASE.V701.P5',
        ],
    },
];

@Component({
    selector: 'app-release-notes',
    templateUrl: './release-notes.component.html',
    standalone: false,
})
export class ReleaseNotesComponent {
    readonly releases = RELEASES;

    /** The version this build is, shown in the header. */
    readonly currentVersion = APP_VERSION;
}
